import { render, staticRenderFns } from "./TemplateCharacterChooseDialog.vue?vue&type=template&id=fb1a92c4&scoped=true"
import script from "./TemplateCharacterChooseDialog.vue?vue&type=script&lang=js"
export * from "./TemplateCharacterChooseDialog.vue?vue&type=script&lang=js"
import style0 from "./TemplateCharacterChooseDialog.vue?vue&type=style&index=0&id=fb1a92c4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb1a92c4",
  null
  
)

export default component.exports